import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class FieldLabel extends React.Component {
  static propTypes = {
    mode: PropTypes.oneOf(['info', 'success', 'danger', 'warning']),
    align: PropTypes.oneOf(['left', 'right', 'center']),
    htmlFor: PropTypes.string.isRequired,
    className: PropTypes.string,
    required: PropTypes.bool,
    children: PropTypes.node,
  };

  static defaultProps = {
    mode: undefined,
    align: 'right',
    required: false,
    className: undefined,
    children: null,
  };

  render() {
    const { align, required, htmlFor, mode, children, className } = this.props;

    const labelClasses = clx(className, {
      label: true,
      [`mode-${mode}`]: mode,
      [`align-${align}`]: align,
      required,
    });

    return (
      <label htmlFor={htmlFor} className={labelClasses}>
        {children}
      </label>
    );
  }
}
